import Isotope from 'isotope-layout';

export default class LatestUpdatesModule {

  constructor (element) {
    this.element = element;
    this.iso = null;

    this.init();
  }

  handleFilterUpdate (el) {

    const checkedValues = Array.from(
      el.querySelectorAll('input[type="checkbox"]:checked'),
    ).map(cb => cb.value);

    const filterSelector = checkedValues
      .map(val => `[data-category="${val}"]`)
      .join(', ');

    this.iso.arrange({
      filter: filterSelector || '*',
    });

  }

  init () {
    const grid = this.element.querySelector('.grid');
    const filter = this.element.querySelector('.grid-filter');

    const settings = {
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer',
      },
      getSortData: {
        category: '[data-category]',
      },
    };

    this.iso = new Isotope(grid, settings);
    this.iso.shuffle();

    filter.addEventListener('change', this.handleFilterUpdate.bind(this, filter));
  }

}